import { render, staticRenderFns } from "./JoinGoodsCarShowDialog.vue?vue&type=template&id=a2f0a010"
import script from "./JoinGoodsCarShowDialog.vue?vue&type=script&lang=js"
export * from "./JoinGoodsCarShowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports